var map = {
	"./components/Avatar": 165,
	"./components/Avatar.jsx": 165,
	"./components/Capsule": 67,
	"./components/Capsule.jsx": 67,
	"./components/CloseButton": 98,
	"./components/CloseButton.jsx": 98,
	"./components/Details": 34,
	"./components/Details.jsx": 34,
	"./components/ErrorTracker": 236,
	"./components/ErrorTracker.jsx": 236,
	"./components/ExternalLink": 18,
	"./components/ExternalLink.jsx": 18,
	"./components/FooterCTA": 166,
	"./components/FooterCTA.jsx": 166,
	"./components/InfiniteModal": 32,
	"./components/InfiniteModal.jsx": 32,
	"./components/Loading": 316,
	"./components/Loading.jsx": 316,
	"./components/Logo": 167,
	"./components/Logo.jsx": 167,
	"./components/Modal": 168,
	"./components/Modal.jsx": 168,
	"./components/ModalCard": 156,
	"./components/ModalCard/": 156,
	"./components/ModalCard/BlockchainProofSection": 68,
	"./components/ModalCard/BlockchainProofSection.jsx": 68,
	"./components/ModalCard/CertificateCard": 69,
	"./components/ModalCard/CertificateCard.jsx": 69,
	"./components/ModalCard/ClaimDescription": 175,
	"./components/ModalCard/ClaimDescription.jsx": 175,
	"./components/ModalCard/ClaimsSection": 176,
	"./components/ModalCard/ClaimsSection.jsx": 176,
	"./components/ModalCard/CollaboratorActivity": 105,
	"./components/ModalCard/CollaboratorActivity.jsx": 105,
	"./components/ModalCard/ConnectionCard": 177,
	"./components/ModalCard/ConnectionCard.jsx": 177,
	"./components/ModalCard/Container": 179,
	"./components/ModalCard/Container.jsx": 179,
	"./components/ModalCard/DescriptionSection": 209,
	"./components/ModalCard/DescriptionSection.jsx": 209,
	"./components/ModalCard/EvidenceCard": 58,
	"./components/ModalCard/EvidenceCard.jsx": 58,
	"./components/ModalCard/EvidenceFromActivitySection": 213,
	"./components/ModalCard/EvidenceFromActivitySection.jsx": 213,
	"./components/ModalCard/EvidenceSection": 200,
	"./components/ModalCard/EvidenceSection.jsx": 200,
	"./components/ModalCard/EvidenceVerifierSection": 212,
	"./components/ModalCard/EvidenceVerifierSection.jsx": 212,
	"./components/ModalCard/EvidencedMeaning": 100,
	"./components/ModalCard/EvidencedMeaning.jsx": 100,
	"./components/ModalCard/Footer": 35,
	"./components/ModalCard/Footer.jsx": 35,
	"./components/ModalCard/FullCertificateCard": 219,
	"./components/ModalCard/FullCertificateCard.jsx": 219,
	"./components/ModalCard/FullEvidenceCard": 218,
	"./components/ModalCard/FullEvidenceCard.jsx": 218,
	"./components/ModalCard/FullOrganizationCard": 180,
	"./components/ModalCard/FullOrganizationCard.jsx": 180,
	"./components/ModalCard/Header": 70,
	"./components/ModalCard/Header.jsx": 70,
	"./components/ModalCard/HowAchievedSection": 201,
	"./components/ModalCard/HowAchievedSection.jsx": 201,
	"./components/ModalCard/LocationSection": 106,
	"./components/ModalCard/LocationSection.jsx": 106,
	"./components/ModalCard/MeaningSection": 170,
	"./components/ModalCard/MeaningSection.jsx": 170,
	"./components/ModalCard/NetworkVerificationSection": 178,
	"./components/ModalCard/NetworkVerificationSection.jsx": 178,
	"./components/ModalCard/OrganizationCard": 181,
	"./components/ModalCard/OrganizationCard.jsx": 181,
	"./components/ModalCard/ProductSummary": 202,
	"./components/ModalCard/ProductSummary.jsx": 202,
	"./components/ModalCard/Profile": 111,
	"./components/ModalCard/Profile.jsx": 111,
	"./components/ModalCard/ProofPointsSection": 182,
	"./components/ModalCard/ProofPointsSection.jsx": 182,
	"./components/ModalCard/QuoteSection": 210,
	"./components/ModalCard/QuoteSection.jsx": 210,
	"./components/ModalCard/RecyclingCard": 217,
	"./components/ModalCard/RecyclingCard.jsx": 217,
	"./components/ModalCard/StickyHeader": 25,
	"./components/ModalCard/StickyHeader.jsx": 25,
	"./components/ModalCard/ThemeSection": 102,
	"./components/ModalCard/ThemeSection.jsx": 102,
	"./components/ModalCard/ThemeSectionV1": 103,
	"./components/ModalCard/ThemeSectionV1.jsx": 103,
	"./components/ModalCard/ThirdPartyVerification": 101,
	"./components/ModalCard/ThirdPartyVerification.jsx": 101,
	"./components/ModalCard/VerificationSection": 211,
	"./components/ModalCard/VerificationSection.jsx": 211,
	"./components/ModalCard/VerifierSection": 174,
	"./components/ModalCard/VerifierSection.jsx": 174,
	"./components/ModalCard/about/AboutCard": 75,
	"./components/ModalCard/about/AboutCard.jsx": 75,
	"./components/ModalCard/about/AboutCardForInfiniteModal": 74,
	"./components/ModalCard/about/AboutCardForInfiniteModal.jsx": 74,
	"./components/ModalCard/index": 156,
	"./components/ModalCard/index.js": 156,
	"./components/ModalCard/recycling/Attribution": 113,
	"./components/ModalCard/recycling/Attribution.jsx": 113,
	"./components/ModalCard/recycling/Error": 208,
	"./components/ModalCard/recycling/Error.jsx": 208,
	"./components/ModalCard/recycling/Facilities": 205,
	"./components/ModalCard/recycling/Facilities.jsx": 205,
	"./components/ModalCard/recycling/Facility": 206,
	"./components/ModalCard/recycling/Facility.jsx": 206,
	"./components/ModalCard/recycling/Lookup": 203,
	"./components/ModalCard/recycling/Lookup.jsx": 203,
	"./components/ModalCard/recycling/Packaging": 73,
	"./components/ModalCard/recycling/Packaging.jsx": 73,
	"./components/ModalCard/recycling/Results": 112,
	"./components/ModalCard/recycling/Results.jsx": 112,
	"./components/ModalCard/recycling/Scheme": 204,
	"./components/ModalCard/recycling/Scheme.jsx": 204,
	"./components/ModalCard/recycling/Unrecyclable": 207,
	"./components/ModalCard/recycling/Unrecyclable.jsx": 207,
	"./components/ModalCard/stories/StoryButtonList": 54,
	"./components/ModalCard/stories/StoryButtonList.jsx": 54,
	"./components/ModalCard/stories/StoryCard": 183,
	"./components/ModalCard/stories/StoryCard.jsx": 183,
	"./components/ModalCard/stories/StoryCardListForInfiniteModal": 72,
	"./components/ModalCard/stories/StoryCardListForInfiniteModal.jsx": 72,
	"./components/PoweredByProvenance": 169,
	"./components/PoweredByProvenance.jsx": 169,
	"./components/ProofPointStatus": 24,
	"./components/ProofPointStatus.jsx": 24,
	"./components/StaticCapsuleList": 214,
	"./components/StaticCapsuleList.jsx": 214,
	"./components/TagLine": 53,
	"./components/TagLine.jsx": 53,
	"./components/UserProfile": 114,
	"./components/UserProfile.jsx": 114,
	"./components/Wordmark": 339,
	"./components/Wordmark.jsx": 339,
	"./components/claims/AttachmentLink": 340,
	"./components/claims/AttachmentLink.jsx": 340,
	"./components/claims/BackFooter": 341,
	"./components/claims/BackFooter.jsx": 341,
	"./components/claims/Card": 342,
	"./components/claims/Card.jsx": 342,
	"./components/claims/ClaimCard": 118,
	"./components/claims/ClaimCard.jsx": 118,
	"./components/claims/ClaimCardEmbed": 343,
	"./components/claims/ClaimCardEmbed.jsx": 343,
	"./components/claims/ClaimCardPJ": 189,
	"./components/claims/ClaimCardPJ.jsx": 189,
	"./components/claims/ClaimVerifier": 119,
	"./components/claims/ClaimVerifier.jsx": 119,
	"./components/claims/CollaborationBack": 222,
	"./components/claims/CollaborationBack.jsx": 222,
	"./components/claims/CollaborationCard": 39,
	"./components/claims/CollaborationCard.jsx": 39,
	"./components/claims/CollaborationCardPJ": 344,
	"./components/claims/CollaborationCardPJ.jsx": 344,
	"./components/claims/CollaborationFront": 224,
	"./components/claims/CollaborationFront.jsx": 224,
	"./components/claims/ConnectionCard": 345,
	"./components/claims/ConnectionCard.jsx": 345,
	"./components/claims/FullCard": 225,
	"./components/claims/FullCard.jsx": 225,
	"./components/claims/Icon": 346,
	"./components/claims/Icon.jsx": 346,
	"./components/claims/ProofPoint": 107,
	"./components/claims/ProofPoint.jsx": 107,
	"./components/claims/SelectCardList": 347,
	"./components/claims/SelectCardList.jsx": 347,
	"./components/claims/getThemeClass": 231,
	"./components/claims/getThemeClass.js": 231,
	"./components/claims/icons/AnimalWelfare": 226,
	"./components/claims/icons/AnimalWelfare.jsx": 226,
	"./components/claims/icons/Arrow": 116,
	"./components/claims/icons/Arrow.jsx": 116,
	"./components/claims/icons/Chevron": 117,
	"./components/claims/icons/Chevron.jsx": 117,
	"./components/claims/icons/EnvironmentalImpact": 227,
	"./components/claims/icons/EnvironmentalImpact.jsx": 227,
	"./components/claims/icons/HealthNutrition": 228,
	"./components/claims/icons/HealthNutrition.jsx": 228,
	"./components/claims/icons/SafetyQuality": 229,
	"./components/claims/icons/SafetyQuality.jsx": 229,
	"./components/claims/icons/SocialImpact": 230,
	"./components/claims/icons/SocialImpact.jsx": 230,
	"./components/feedback/Feedback": 37,
	"./components/feedback/Feedback.jsx": 37,
	"./components/feedback/Option": 173,
	"./components/feedback/Option.jsx": 173,
	"./components/feedback/ReportEvidenceLink": 348,
	"./components/feedback/ReportEvidenceLink.jsx": 348,
	"./components/icons/CloseIcon": 99,
	"./components/icons/CloseIcon.jsx": 99,
	"./components/icons/DocumentIcon": 220,
	"./components/icons/DocumentIcon.jsx": 220,
	"./components/icons/ExternalLinkIcon": 51,
	"./components/icons/ExternalLinkIcon.jsx": 51,
	"./components/icons/FlagIcon": 71,
	"./components/icons/FlagIcon.jsx": 71,
	"./components/icons/HelpIcon": 196,
	"./components/icons/HelpIcon.jsx": 196,
	"./components/icons/LeftIcon": 198,
	"./components/icons/LeftIcon.jsx": 198,
	"./components/icons/Link": 186,
	"./components/icons/Link.jsx": 186,
	"./components/icons/PhotoIcon": 221,
	"./components/icons/PhotoIcon.jsx": 221,
	"./components/icons/PlayIcon": 349,
	"./components/icons/PlayIcon.jsx": 349,
	"./components/icons/RightIcon": 199,
	"./components/icons/RightIcon.jsx": 199,
	"./components/icons/Share": 194,
	"./components/icons/Share.jsx": 194,
	"./components/icons/SwipeIcon": 232,
	"./components/icons/SwipeIcon.jsx": 232,
	"./components/icons/ThumbsDownIcon": 172,
	"./components/icons/ThumbsDownIcon.jsx": 172,
	"./components/icons/ThumbsUpIcon": 171,
	"./components/icons/ThumbsUpIcon.jsx": 171,
	"./components/icons/TickIcon": 350,
	"./components/icons/TickIcon.jsx": 350,
	"./components/icons/VerifiedTickIcon": 223,
	"./components/icons/VerifiedTickIcon.jsx": 223,
	"./components/images/Placeholder": 104,
	"./components/images/Placeholder.jsx": 104,
	"./components/journeys/Brand": 192,
	"./components/journeys/Brand.jsx": 192,
	"./components/journeys/Close": 36,
	"./components/journeys/Close.jsx": 36,
	"./components/journeys/CoverView": 109,
	"./components/journeys/CoverView.jsx": 109,
	"./components/journeys/CoverViewContainer": 351,
	"./components/journeys/CoverViewContainer.jsx": 351,
	"./components/journeys/CreditsView": 184,
	"./components/journeys/CreditsView.jsx": 184,
	"./components/journeys/Drawer": 145,
	"./components/journeys/Drawer.jsx": 145,
	"./components/journeys/Header": 191,
	"./components/journeys/Header.jsx": 191,
	"./components/journeys/HelpButton": 195,
	"./components/journeys/HelpButton.jsx": 195,
	"./components/journeys/Journey": 352,
	"./components/journeys/Journey.jsx": 352,
	"./components/journeys/Navigation": 197,
	"./components/journeys/Navigation.jsx": 197,
	"./components/journeys/NextButton": 353,
	"./components/journeys/NextButton.jsx": 353,
	"./components/journeys/Organization": 185,
	"./components/journeys/Organization.jsx": 185,
	"./components/journeys/Progress": 115,
	"./components/journeys/Progress.jsx": 115,
	"./components/journeys/ProgressBar": 215,
	"./components/journeys/ProgressBar.jsx": 215,
	"./components/journeys/ProvenanceValue": 354,
	"./components/journeys/ProvenanceValue.jsx": 354,
	"./components/journeys/Share": 187,
	"./components/journeys/Share.jsx": 187,
	"./components/journeys/ShareButton": 193,
	"./components/journeys/ShareButton.jsx": 193,
	"./components/journeys/ShareIcon": 355,
	"./components/journeys/ShareIcon.jsx": 355,
	"./components/journeys/Slide": 110,
	"./components/journeys/Slide.jsx": 110,
	"./components/journeys/Slider": 108,
	"./components/journeys/Slider.jsx": 108,
	"./components/journeys/StageHeader": 356,
	"./components/journeys/StageHeader.jsx": 356,
	"./components/journeys/SwipePrompt": 357,
	"./components/journeys/SwipePrompt.jsx": 357,
	"./components/journeys/VideoSlideContent": 190,
	"./components/journeys/VideoSlideContent.jsx": 190,
	"./components/journeys/callbacks": 77,
	"./components/journeys/callbacks.js": 77,
	"./components/poll/Organization": 233,
	"./components/poll/Organization.jsx": 233,
	"./components/poll/Poll": 234,
	"./components/poll/Poll.jsx": 234,
	"./components/poll/PollContainer": 358,
	"./components/poll/PollContainer.jsx": 358,
	"./components/poll/PollOption": 235,
	"./components/poll/PollOption.jsx": 235,
	"./components/ui/Snackbar": 188,
	"./components/ui/Snackbar.jsx": 188,
	"./utils/analytics": 52,
	"./utils/analytics.js": 52,
	"./utils/hover": 359,
	"./utils/hover.js": 359,
	"./utils/mouse": 216,
	"./utils/mouse.js": 216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 445;